module.exports = __webpack_public_path__ + "static/media/socials-tumblr-icon-svgrepo-com.25c29c8c.svg";